/**
 * MY MENTIONS (MENTIONS.md) — the signed-in person's unread @-mentions in the active workspace.
 *   GET  /auth/mentions       → { rooms: {"networkId:poolId": n}, total, items: [{networkId, poolId, roomName, fromName, excerpt, at}] }
 *   POST /auth/mentions/read  { networkId, poolId } → { cleared }
 */
import { getRestApiBearerToken } from './apiToken';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.stepflow.dev';

async function call(path, init = {}) {
  const token = getRestApiBearerToken();
  if (!token) throw new Error('Not authenticated');
  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...init, headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', ...(init.headers || {}) } });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || data.error || `HTTP ${res.status}`);
  return data;
}

export const getMyMentions = () => call('/auth/mentions');
export const markMentionsRead = (networkId, poolId) =>
  call('/auth/mentions/read', { method: 'POST', body: JSON.stringify({ networkId, poolId }) });

/** ROOM UNREAD (MENTIONS.md §5) — rooms with activity since I last looked → { rooms: ["net:pool"], activity }. */
export const getUnreadRooms = () => call('/auth/rooms/seen');
/** I'm caught up on this room. */
export const markRoomSeen = (networkId, poolId) =>
  call('/auth/rooms/seen', { method: 'POST', body: JSON.stringify({ networkId, poolId }) });
